import { LabelsRowActions } from 'modules/inventory/settings/labels/components/LabelsRowActions';
import { EditLink, HeadCell } from '@dfl/mui-admin-layout';
import { ILabels } from 'modules/inventory/settings/labels/interfaces';
import { LABELS_PERMISSIONS } from 'modules/inventory/settings/labels/constants/labels.permissions';
import { createdATColumn } from 'modules/cms/testimony/constants';

export const labelsNameColumn: HeadCell<ILabels> = {
  field: 'name',
  headerName: 'labels:fields.name',
  disablePadding: false,
  renderCell: (name: string, data?: ILabels) => (<EditLink entityId={data?._id as string}>{name}</EditLink>),
};

export const labelsActionsColumn: HeadCell<ILabels> = {
  field: 'actions',
  sortable: false,
  width: 100,
  permissions: LABELS_PERMISSIONS.LABELS_WRITE,
  headerName: 'common:actions',
  disablePadding: true,
  component: LabelsRowActions,
};

export const labelsColumns: Array<HeadCell<any>> = [
  labelsNameColumn,
  createdATColumn,
  labelsActionsColumn
];
